var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c(
      "input",
      _vm._g(
        {
          staticClass: "form-control",
          attrs: {
            type: "password",
            id: _vm.id,
            npkencrypt: "on",
            "data-keypad-type": "number",
            "data-keypad-theme": "mobile",
            "data-keypad-extend-ui": "pw",
            "data-keypad-next": "__hide__",
            maxlength: "4"
          },
          domProps: { value: _vm.validationData }
        },
        _vm.NOS_INSTANCE.listeners()
      )
    ),
    _c("input", {
      attrs: { type: "hidden" },
      domProps: { value: _vm.validationData }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }